import { BookOpen, Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { QuickCreateColonyModal } from "@/components/QuickCreateColonyModal";
import { useState } from "react";

interface KnowledgeEmptyStateProps {
  type: "no-colonies" | "select-colony" | "no-files";
  colonyName?: string;
}

export function KnowledgeEmptyState({ type, colonyName }: KnowledgeEmptyStateProps) {
  const [showCreateModal, setShowCreateModal] = useState(false);

  if (type === "no-colonies") {
    return (
      <>
        <div className="flex-1 flex items-center justify-center">
          <div className="text-center px-6 py-12">
            <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-secondary flex items-center justify-center">
              <BookOpen size={32} className="text-muted-foreground" />
            </div>
            <h2 className="ios-title-3 text-foreground mb-3">No Colonies Yet</h2>
            <p className="ios-body text-muted-foreground mb-6 max-w-sm">
              Create your first colony to start building a knowledge base with AI assistants.
            </p>
            <Button 
              onClick={() => setShowCreateModal(true)}
              className="ios-button-large w-full max-w-xs"
            >
              <Plus size={20} className="mr-2" />
              Create Your First Colony
            </Button>
          </div>
        </div>
        <QuickCreateColonyModal
          isOpen={showCreateModal}
          onClose={() => setShowCreateModal(false)}
        />
      </>
    );
  }

  if (type === "select-colony") {
    return (
      <div className="flex-1 flex items-center justify-center">
        <div className="text-center px-6 py-12">
          <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-secondary flex items-center justify-center">
            <BookOpen size={32} className="text-muted-foreground" />
          </div>
          <h2 className="ios-title-3 text-foreground mb-3">Select a Colony</h2>
          <p className="ios-body text-muted-foreground max-w-sm">
            Choose a colony from the dropdown above to view or upload its knowledge base.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="text-center py-12">
      <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-secondary flex items-center justify-center">
        <BookOpen size={24} className="text-muted-foreground" />
      </div>
      <h3 className="ios-headline text-foreground mb-2">No Knowledge Files Yet</h3>
      <p className="ios-body text-muted-foreground mb-4 max-w-sm mx-auto">
        Upload files to add them to {colonyName}'s knowledge base.
      </p>
      <p className="ios-caption-1 text-muted-foreground">
        Drag and drop files above or click to browse
      </p>
    </div>
  );
}